import {Component, OnInit} from '@angular/core';
import {Router} from "@angular/router";
import {Subscription, SubscriptionStatus} from '../models/Subscription';
import {SubscriptionService} from '../services/subscription.service';
import {HttpErrorResponse} from "@angular/common/http";
import {UpdateSubscriptionStatusRequestDto} from "../models/updateSubscriptionStatusRequestDto";

@Component({
  selector: 'app-subscriptions',
  templateUrl: './subscriptions.component.html',
  styleUrls: ['./subscriptions.component.css']
})
export class SubscriptionsComponent implements OnInit {
  subscriptions: Subscription[] = [];
  loading = true;
  protected readonly SubscriptionStatus = SubscriptionStatus;

  constructor(
    private readonly router: Router,
    private readonly subscriptionService: SubscriptionService
  ) {
  }

  ngOnInit(): void {
    this.loadSubscriptions();
  }

  loadSubscriptions(): void {
    this.loading = true;
    this.subscriptionService.getSubscriptions().subscribe({
      next: (data: Array<Subscription>): void => {
        this.subscriptions = data;
        this.loading = false;
      },
      error: (error: HttpErrorResponse) => {
        this.loading = false;
        throw new Error('Error fetching subscriptions', error.error);
      }
    });
  }

  formatPrice(price: number): string {
    return `$${price.toFixed(2)}`;
  }

  calculateTotalAnnualPrice(subscription: Subscription): string {
    const annualRate = subscription.discountedAnnualRate || subscription.monthlyPrice;
    return this.formatPrice(annualRate * 12);
  }

  updateSubscriptionStatus(subscriptionId: string, newStatus: SubscriptionStatus): void {
    const request: UpdateSubscriptionStatusRequestDto = {
      id: subscriptionId,
      status: newStatus
    };

    this.subscriptionService.updateSubscriptionStatus(request).subscribe({
      next: () => {
        const archivedSubscription: Subscription = this.subscriptions.find(subscription => subscription.id === subscriptionId)!;
        archivedSubscription.status = newStatus;
      },
      error: (error: HttpErrorResponse) => {
        throw new Error('Error updating subscription status', error.error);
      }
    });
  }

  editSubscription(id: string): void {
    this.router.navigate(['/subscriptions/manage', id]).then();
  }

  viewSubscriptionDetails(subscription: Subscription): void {
    // TODO: Implement viewing subscription details in a modal
  }
}
